import React, { useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ContainerComponent from './ContainerComponent';
import { SET_VALUE } from '../formReducer';

interface Props {
  value: any;
  formId: string;
  formName: string;
  formDispatch: any;
  item: {
    label: string;
    name: string;
    placeholder?: string;
    subtype?: string;
    required?: boolean;
    values: { value: any; label: string }[];
    description?: string;
  };
  readOnly: boolean;
}

const decodeHtmlEntities = (str: string) => {
  if (!str) return str;
  const txt = typeof window !== 'undefined' ? document.createElement('textarea') : null;
  if (!txt) return str;
  txt.innerHTML = str;
  return txt.value;
};

const SelectFieldComponent: React.FC<Props> = ({
  value,
  formDispatch,
  formId,
  formName,
  item: { label, values, name: fieldId, required, description },
  readOnly,
}) => {
  useEffect(() => {
    formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
    formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = ({ target: { value } }: any) => {
    formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
    formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
  };

  return (
    <ContainerComponent label={label} required={!!required} description={description}>
      <FormControl style={{ width: '100%' }}>
        <Select
          value={value ?? ''}
          onChange={handleChange}
          style={{ fontSize: 14 }}
          disabled={readOnly}
          variant={'standard' as any}
        >
          {Array.isArray(values) && values.map(({ value, label }) => (
            <MenuItem key={label} value={value} style={{ fontSize: 14 }}>
              {decodeHtmlEntities(label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ContainerComponent>
  );
};

export default SelectFieldComponent;
